import Moment from 'react-moment';
import React from 'react';
import { withI18n } from '@lingui/react';
import { useNavigate } from 'react-router-dom';
import { TransButtonLink } from '../../../Atoms/Buttons';

export default withI18n()(({ i18n, messageTemplate }) => {
  const navigate = useNavigate();

  return (
    <div>
      <div style={{ display: 'flex' }}>
        <TransButtonLink
          style={{ fontSize: '1rem', color: '#000000', height: 25 }}
          onClick={() =>
            navigate(
              `/settings/template/message/${messageTemplate.messageType.toLowerCase()}${
                messageTemplate.name ? `/${messageTemplate.name}` : ''
              }`,
            )
          }
          text={
            messageTemplate.name
              ? messageTemplate.name
              : i18n._(`message.type.${messageTemplate.messageType.toLowerCase()}`)
          }
        />
      </div>
      <div>
        {messageTemplate.lastModified && (
          <span style={{ fontSize: '0.75rem' }}>
            Bearbeitet <Moment fromNow>{messageTemplate.lastModified}</Moment>
          </span>
        )}
      </div>
    </div>
  );
});
